/**
 * Cart view
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider.state('participants', {
        url: '/' + urls.order.participants.fr, // TODO : when multilang, change this to something dynamic
        controller: ['$scope', 'cart', 'tools', '$filter', function ($scope, cart, tools, $filter) {
            $scope.tools = tools;
            $scope.loading = false;

            $scope.titlePanel = $filter('translate')('cart.participants');

            $scope.optionsCivility = [
                { text: $filter('translate')('form.male'), value: 'M' },
                { text: $filter('translate')('form.female'), value: 'Mme' }
            ];

            cart.getCart().then(function (cart) {
                $scope.cart = cart;

                // Init form data
                $scope.internships = [];
                $scope.cart.internships.forEach(function (internship, index) {
                    $scope.internships.push({ participants: [] });
                    tools.getRange(1, internship.field_quantity).forEach(function () {
                        $scope.internships[index].participants.push({});
                    });
                });
            });

            // Updates participant with authenticated user
            $scope.updateParticipant = function (participant, direction) {
                for (var key in $scope.cart.user) {
                    participant[key] = direction ? $scope.cart.user[key] : null;
                }
            };

            $scope.pay = function () {
                console.log('form:', $scope.participantForm);
                // console.log('pay:', $scope.internships);
            };
        }],
        templateUrl: 'src/views/participants/participants.html'
    });
}]);
